
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign_up",
      function () {
        return require("private-next-pages/auth/sign_up/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/sign_up"])
      });
    }
  